import { createWithEqualityFn } from 'zustand/traditional'
import { persist, createJSONStorage } from 'zustand/middleware'

interface AppStore {
	prevPage: string | null
	hasFetchProfile: boolean
	setPrevPage: (prevPage: string | null) => void
	setHasFetchProfile: (hasFetchProfile: boolean) => void
}

export const useAppStore = createWithEqualityFn(
	persist<AppStore>(
		set => ({
			prevPage: null,
			hasFetchProfile: false,
			setPrevPage: (prevPage: string | null) => {
				set({ prevPage })
			},
			setHasFetchProfile: (hasFetchProfile: boolean) => {
				set({ hasFetchProfile })
			},
		}),
		{
			name: 'kumopack-supplier-app-storage',
			storage: createJSONStorage(() => localStorage),
			// @ts-ignore
			partialize: state => ({
				prevPage: state.prevPage,
			}),
		}
	),
	Object.is
)
